import { render, staticRenderFns } from "./EditSyllabusDateModal.vue?vue&type=template&id=4bcceb76"
import script from "./EditSyllabusDateModal.vue?vue&type=script&lang=js"
export * from "./EditSyllabusDateModal.vue?vue&type=script&lang=js"
import style0 from "./EditSyllabusDateModal.vue?vue&type=style&index=0&id=4bcceb76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports